import { Component, Input } from '@angular/core';
import { OrderSettings } from 'app/orders/settings/settings.model';
import { UserSettingsService } from 'app/user/user-settings.service';

@Component({
  selector: 'order-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class OrderSettingsComponent {

  @Input()
  settings: OrderSettings;

  get showRegion(): boolean {
    return this._userSettingsService.serviceType === 'ic';
  }

  constructor(private _userSettingsService: UserSettingsService) { }
}
